module.exports = __webpack_public_path__ + "img/LogoSportsCapital_Gris.fb364924.png";